import { useAuthentication } from '@psyomics/ui-common';
import { AppShell, PatientAppBar } from '@psyomics/ui-components';
import { Outlet } from 'react-router-dom';

import { usePatientAppBarContext } from '../../contexts/patient-app-bar';

function SecureLayout() {
  const { isAuthenticated } = useAuthentication();
  const { showUrgentHelp, setShowUrgentHelp } = usePatientAppBarContext();

  if (!isAuthenticated) return null;

  return (
    <AppShell
      header={
        <PatientAppBar
          iconHref="/account"
          logoHref="/"
          onShowUrgentHelpDialogChange={setShowUrgentHelp}
          showUrgentHelpDialog={showUrgentHelp}
        />
      }
    >
      <Outlet />
    </AppShell>
  );
}

export { SecureLayout };
